import { useState } from 'react';

// todo: this belongs in redux, but investment app migration to redux is a tad bit tricky
const useEditIssuerData = () => {
  const [isEditCeoOpen, setEditCeoOpen] = useState(false);

  const [isEditBankAccountOpen, setEditBankAccountOpen] = useState(false);

  const [isEditConfigurationOpen, setEditConfigurationOpen] = useState(false);

  const [isSuccessEditOpen, setSuccessEditOpen] = useState(false);

  const setEditBankAccountModal = (value: boolean) => {
    setEditBankAccountOpen(value);
  };

  const setEditCeoModal = (value: boolean) => {
    setEditCeoOpen(value);
  };

  const setEditConfigurationModal = (value: boolean) => {
    setEditConfigurationOpen(value);
  };

  const setSuccessModal = (value: boolean) => {
    setSuccessEditOpen(value);
  };

  return {
    isEditCeoOpen,
    isEditBankAccountOpen,
    isEditConfigurationOpen,
    isSuccessEditOpen,
    setEditCeoModal,
    setEditBankAccountModal,
    setEditConfigurationModal,
    setSuccessModal,
  };
};

export default useEditIssuerData;
